import { Component, input } from '@angular/core';
import * as fromAssistants from '../assistants';
import { TeammateAvatarComponent } from '../teammates/teammate-avatar.component';
import { TeammateAvatarConfig } from '../teammates/teammate-avatar.config';

@Component({
  selector: 'squadbox-introduction',
  imports: [fromAssistants.AssistantLogoComponent, TeammateAvatarComponent],
  template: `
    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-6 tablet-landscape:gap-4">
        <!-- Image -->
        <div
          class="size-14 tablet-landscape:size-16 overflow-hidden rounded-lg relative"
          [class.bg-primary-100]="!teammate()"
          [class.p-4]="!teammate()"
        >
          @if (teammate()) {
            <squadbox-teammate-avatar
              class="h-full w-full"
              [avatar]="avatar()!"
              variant="large"
            />
          } @else {
            <squadbox-assistant-logo
              class="
                [&>svg,img]:text-primary-500/50
              "
              [logo]="imagePath()"
            />
          }
        </div>

        <!-- Description and subtitle -->
        <div class="typo-h6 wrap-anywhere">
          <span>{{ title() }}</span>
          @if (subtitle()) {
            <p class="text-neutral-500">{{ subtitle() }}</p>
          }
        </div>
      </div>

      <!-- Divider -->
      <div class="border-t border-neutral-200"></div>
    </div>
  `,
})
export class IntroductionComponent {
  public readonly teammate = input<boolean>(false);
  /** Assistant-logo identifier — used in the non-teammate branch. */
  public readonly imagePath = input<string>('');
  /** Resolved teammate avatar — required when `teammate` is true. */
  public readonly avatar = input<TeammateAvatarConfig>();
  public readonly title = input.required<string>();
  public readonly subtitle = input<string>();
}
